import React from 'react';
export function BonusesSection() {
  const bonuses = [{
    title: '10 Días de Reprogramación Cuántica',
    description: 'Programa intensivo para reprogramar tu mente subconsciente',
    value: '$8.000'
  }, {
    title: '50 Afirmaciones de Alta Vibración',
    description: 'Biblioteca completa de afirmaciones potentes',
    value: '$5.000'
  }, {
    title: '8 Meditaciones para un Salto Cuántico',
    description: 'Audios guiados para acelerar tu transformación',
    value: '$7.000'
  }, {
    title: 'Limpieza Energética del Hogar',
    description: 'Guía completa para purificar y elevar tu espacio',
    value: '$5.000'
  }, {
    title: 'Guía de los 7 Arcángeles',
    description: 'Conexión espiritual con guías para cada área de vida',
    value: '$5.000'
  }, {
    title: 'Manual de Manifestación Express',
    description: 'Técnicas rápidas para resultados acelerados',
    value: '$5.000'
  }];
  return <section className="px-4 py-7 sm:py-9 bg-dark-card/30 border-t border-brand-gold/10" data-id="element-22">
      <div className="max-w-6xl mx-auto" data-id="element-23">
        <h2 className="font-serif text-2xl sm:text-3xl md:text-4xl font-bold text-center mb-4 sm:mb-5" data-id="element-24">
          Además recibís <span className="text-brand-gold" data-id="element-25">gratis</span>
        </h2>

        {/* Banner image showing all bonuses */}
        <div className="mb-5 sm:mb-6" data-id="element-26">
          <img src="https://cdn.magicpatterns.com/uploads/dMH68Y414BcRhaRCz9sPas/banner-cta.png" alt="Regalos complementarios - bonos incluidos" className="w-full max-w-2xl mx-auto" data-id="element-27" />
        </div>

        <div className="grid grid-cols-2 gap-2.5 sm:gap-4 mb-5" data-id="element-28">
          {bonuses.map((bonus, i) => <div key={i} className="bg-dark-card border border-brand-gold/30 rounded-lg p-3 sm:p-4" data-id="element-29">
              <div className="flex items-start justify-between mb-2 gap-2" data-id="element-30">
                <span className="text-[10px] text-brand-gold/70 font-semibold tracking-wider font-sans" data-id="element-31">
                  BONO {String(i + 1).padStart(2, '0')}
                </span>
                <span className="bg-brand-gold text-brand-black px-2 py-0.5 rounded text-[9px] sm:text-[10px] font-bold" data-id="element-32">
                  GRATIS
                </span>
              </div>
              <h3 className="font-sans text-sm sm:text-base font-semibold mb-1.5 leading-snug" data-id="element-33">
                {bonus.title}
              </h3>
              <p className="text-[11px] sm:text-xs text-brand-gray mb-2 leading-snug" data-id="element-34">
                {bonus.description}
              </p>
              <p className="text-brand-gold text-xs sm:text-sm font-semibold" data-id="element-35">
                Valor: {bonus.value} ARS
              </p>
            </div>)}
        </div>

        <div className="text-center border-t border-brand-gold/30 pt-4" data-id="element-36">
          <p className="text-base sm:text-lg font-semibold" data-id="element-37">
            Valor total de bonos:{' '}
            <span className="text-brand-gray line-through" data-id="element-38">$30.000 ARS</span>
          </p>
          <p className="text-brand-gold text-sm mt-1 font-semibold" data-id="element-39">
            Hoy incluidos sin costo.
          </p>
        </div>
      </div>
    </section>;
}